import { inject, Injectable } from '@angular/core';
import { IconsService } from './icons.service';
import { MenuItem } from '../interface/data-core';
import { ASIGNATURA_COMPONENT_ID, GRADOS_COMPONENT_ID, LISTADO_DINAMICO_ID, LO_MAS_RECIENTE_ID, onAddClass, onRemoveClass, onScrollComponente, openUrl, scrollEnd, toggleClass } from '../utils/generales';
import { environment } from '../../environments/environment';
import { CargarConfService } from './cargar-conf.service';
import { MensajesService } from './mensajes.service';

@Injectable({
    providedIn: 'root'
})
export class MenuService {

    constructor() { }
    public _icon = inject(IconsService);
    public _conf = inject(CargarConfService);
    private mensajeService = inject(MensajesService);
    private readonly url_app: string = environment.url_get_app;


    readonly menuCore: MenuItem[] = [
        {
            title: 'Contenido',
            portal: ['p_default', 'tecnologia', 'lectura', 'preescolar', 'primaria', 'secundaria', 'bac', 'hab'],
            submenu: [
                {
                    icon: this._icon.clock,
                    title: 'Lo más reciente',
                    portal: ['p_default'],
                    action: () => {

                        onScrollComponente(LO_MAS_RECIENTE_ID);
                    }
                },
                {
                    icon: this._icon.grid,
                    title: 'Asignaturas',
                    portal: ['p_default', 'tecnologia', 'lectura', 'primaria', 'secundaria', 'bac', 'hab'],
                    action: () => {

                        onScrollComponente(ASIGNATURA_COMPONENT_ID);
                        onAddClass(LISTADO_DINAMICO_ID, 'onHide');
                    }
                },
                {
                    icon: this._icon.grid,
                    title: 'Campos formativos',
                    portal: ['preescolar'],
                    action: () => {
                        onScrollComponente(ASIGNATURA_COMPONENT_ID);
                        onAddClass(LISTADO_DINAMICO_ID, 'onHide');

                    }
                },
                {
                    icon: this._icon.grades,
                    title: 'Grados',
                    portal: ['p_default', 'lectura', 'primaria', 'secundaria', 'hab'],
                    action: () => {
                        onScrollComponente(GRADOS_COMPONENT_ID);
                        onAddClass(LISTADO_DINAMICO_ID, 'onHide');

                    }
                },
                {
                    icon: this._icon.grades,
                    title: 'Semestres',
                    portal: ['bac'],
                    action: () => {
                        onScrollComponente(GRADOS_COMPONENT_ID);
                        onAddClass(LISTADO_DINAMICO_ID, 'onHide');

                    }
                }

            ],
            action: () => {
            }
        },
        {
            title: 'Ver más',
            portal: ['p_default', 'tecnologia', 'crk', 'lectura', 'preescolar', 'primaria', 'secundaria', 'bac', 'hab'],
            submenu: [
                {
                    icon: this._icon.calendar,
                    title: 'Efemérides',
                    portal: ['p_default', 'primaria'],
                    action: () => {
                        let url = this._conf.localUrl ? environment.url_efemerides : 'https://www.krismar-educa.com.mx/Efemerides/';
                        openUrl(url);
                    }
                },
                {
                    icon: this._icon.select,
                    title: 'Manual de usuario',
                    portal: ['p_default', 'tecnologia', 'lectura', 'preescolar', 'primaria', 'secundaria', 'bachillerato', 'habilidades'],

                    // portal: ['p_default','tecnologia' ,'crk', 'lectura', 'preescolar', 'primaria', 'secundaria', 'bac', 'hab'],
                    action: () => {
                        const url = `assets/docs/${environment.portal}.pdf`;
                        window.open(url, '_blank');
                    }
                }, {
                    icon: this._icon.select,
                    title: 'Manual del docente. Introducción a la robótica',
                    portal: ['crk'],
                    action: () => {
                        const url = `assets/docs/crk_rob_1100.pdf`;
                        window.open(url, '_blank');

                    }
                },

                {
                    icon: this._icon.select,
                    title: 'Planeación didáctica del Nivel 1',
                    portal: ['crk'],
                    action: () => {
                        const url = `assets/docs/crk_rob_1900.pdf`;
                        window.open(url, '_blank');
                    }
                }, {
                    icon: this._icon.select,
                    title: 'Manual del docente. Introducción a la mecánica',
                    portal: ['crk'],
                    action: () => {
                        const url = `assets/docs/crk_mec_1200.pdf`;
                        window.open(url, '_blank');
                    }
                },
                {
                    icon: this._icon.select,
                    title: 'Manual del docente. Introducción a la electrónica ',
                    portal: ['crk'],
                    action: () => {
                        const url = `assets/docs/crk_ele_1300.pdf`;
                        window.open(url, '_blank');
                    }
                },

            ],
            action: () => {
            }
        },
        // Opción Britannica oculta a petición para que no se muestre en el menú
        /*
        {
            title: 'Britannica',
            portal: ['p_default', 'primaria', 'secundaria', 'bac'],
            submenu: [
                {
                    icon: this._icon.britannica,
                    title: 'Escolar',
                    portal: ['p_default', 'secundaria', 'primaria', 'bac'],
                    action: () => {
                        if (this._conf.localUrl) {
                            this.mensajeService.showInfo(this._conf.msgLocalUrl);
                            return
                        }
                        let url = 'http://www.krismar-educa.com.mx/primaria/primaria.php';
                        window.open(url, '_blank');

                    }
                },
                {
                    icon: this._icon.britannica,
                    title: 'School',
                    portal: ['p_default', 'primaria', 'secundaria', 'bac'],
                    action: () => {
                        if (this._conf.localUrl) {
                            this.mensajeService.showInfo(this._conf.msgLocalUrl);
                            return
                        }
                        let url = 'http://www.krismar-educa.com.mx/primaria/escolar.php';
                        window.open(url, '_blank');
                    }
                },
                {
                    icon: this._icon.britannica,
                    title: 'Biografías',
                    portal: ['p_default', 'primaria', 'secundaria', 'bac'],
                    action: () => {
                        if (this._conf.localUrl) {
                            this.mensajeService.showInfo(this._conf.msgLocalUrl);
                            return
                        }
                        let url = 'http://www.krismar-educa.com.mx/primaria/biografias.php';
                        window.open(url, '_blank');
                    }
                },
                {
                    icon: this._icon.britannica,
                    title: 'Mapas',
                    portal: ['p_default', 'primaria', 'secundaria', 'bac'],
                    action: () => {
                        if (this._conf.localUrl) {
                            this.mensajeService.showInfo(this._conf.msgLocalUrl);
                            return
                        }
                        let url = 'http://www.krismar-educa.com.mx/primaria/mapas.php';
                        window.open(url, '_blank');
                    }
                }
            ],
            action: () => {
            }
        },
        */
        {
            title: 'Docente',
            portal: ['p_default',],
            submenu: [
                {
                    icon: this._icon.select,
                    title: 'Reportes de classroom',
                    portal: ['p_default'],
                    action: () => {
                    }
                },
                {
                    icon: this._icon.laptop,
                    title: 'Tutoriales de classroom',
                    portal: ['p_default'],
                    action: () => {
                    }
                }
            ],
            action: () => {
            }
        },
        {
            title: 'Libros',
            portal: ['p_default', 'preescolar', 'primaria', 'secundaria', 'bac'],
            submenu: [
                {
                    icon: this._icon.guias,
                    title: 'Guía para docentes',
                    portal: ['p_default', 'primaria'],
                    action: () => {
                        this._conf.tiposLinkDinamico = 2;
                        this._conf.labelLinks = 'Guía para docentes';
                        this._conf.setlibrosGlobalLinks('primaria_libros_docente');
                        onRemoveClass(LISTADO_DINAMICO_ID, 'onHide');
                        onScrollComponente(LISTADO_DINAMICO_ID);
                    }
                },
                {
                    icon: this._icon.training,
                    title: 'SEP',
                    portal: ['p_default'],
                    action: () => {
                    }
                },
                {
                    icon: this._icon.training,
                    title: 'NEM 2023-2024',
                    portal: ['p_default', 'secundaria'],
                    action: () => {
                        this._conf.labelLinks = 'Libros SEP NEM 2023-2024';
                        this._conf.setlibrosGlobalLinks('secundaria_libros_nem_2023_2024');
                        onRemoveClass(LISTADO_DINAMICO_ID, 'onHide');
                        onScrollComponente(LISTADO_DINAMICO_ID);
                    }
                },
                {
                    icon: this._icon.training,
                    title: 'NEM 2024-2025',
                    portal: ['p_default', 'secundaria'],
                    action: () => {
                        this._conf.labelLinks = 'Libros SEP NEM 2024-2025';
                        this._conf.setlibrosGlobalLinks('secundaria_libros_nem_2024_2025');
                        onRemoveClass(LISTADO_DINAMICO_ID, 'onHide');
                        onScrollComponente(LISTADO_DINAMICO_ID);
                    }
                },
                {
                    icon: this._icon.training,
                    title: 'NEM 2025-2026',
                    portal: ['p_default', 'secundaria'],
                    action: () => {
                        this._conf.labelLinks = 'Libros SEP NEM 2025-2026';
                        this._conf.setlibrosGlobalLinks('secundaria_libros_nem_2025_2026');

                        onRemoveClass(LISTADO_DINAMICO_ID, 'onHide');
                        onScrollComponente(LISTADO_DINAMICO_ID);
                    }
                },
                {
                    icon: this._icon.training,
                    title: 'NEM Telesecundaria 2025-2026',
                    portal: ['p_default', 'secundaria'],
                    action: () => {
                        this._conf.labelLinks = 'Libros SEP NEM Telesecundaria 2025-2026';
                        this._conf.setlibrosGlobalLinks('secundaria_libros_nem_telesecundaria_2025_2026');
                        onRemoveClass(LISTADO_DINAMICO_ID, 'onHide');
                        onScrollComponente(LISTADO_DINAMICO_ID);
                    }
                },
                {
                    icon: this._icon.training,
                    title: 'NEM 2023-2024',
                    portal: ['p_default', 'primaria'],
                    action: () => {
                        this._conf.labelLinks = 'Libros SEP NEM 2023-2024';
                        this._conf.setlibrosGlobalLinks('primaria_libros_nem');
                        onRemoveClass(LISTADO_DINAMICO_ID, 'onHide');
                        onScrollComponente(LISTADO_DINAMICO_ID);
                    }
                },
                {
                    icon: this._icon.training,
                    title: 'NEM 2024-2025',
                    portal: ['p_default', 'primaria'],
                    action: () => {
                        this._conf.labelLinks = 'Libros SEP NEM 2024-2025';
                        this._conf.setlibrosGlobalLinks('primaria_libros_nem_2024_2025');
                        onRemoveClass(LISTADO_DINAMICO_ID, 'onHide');
                        onScrollComponente(LISTADO_DINAMICO_ID);
                    }
                },
                {
                    icon: this._icon.training,
                    title: 'NEM 2025-2026',
                    portal: ['p_default', 'primaria'],
                    action: () => {
                        this._conf.labelLinks = 'Libros SEP NEM 2025-2026';
                        this._conf.setlibrosGlobalLinks('primaria_libros_nem_2025_2026');
                        onRemoveClass(LISTADO_DINAMICO_ID, 'onHide');
                        onScrollComponente(LISTADO_DINAMICO_ID);
                    }
                },
                {
                    icon: this._icon.training,
                    title: 'NEM Educación Indígena',
                    portal: ['p_default', 'primaria'],
                    action: () => {
                        this._conf.labelLinks = 'Libros SEP NEM Educación Indígena';
                        this._conf.setlibrosGlobalLinks('primaria_libros_nem_indigena_2024_2025');
                        onRemoveClass(LISTADO_DINAMICO_ID, 'onHide');
                        onScrollComponente(LISTADO_DINAMICO_ID);
                    }
                },
                {
                    icon: this._icon.training,
                    title: 'NEM 2025-2026',
                    portal: ['p_default', 'preescolar'],
                    action: () => {
                        this._conf.labelLinks = 'Libros SEP NEM 2025-2026';
                        this._conf.setlibrosGlobalLinks('preescolar_libros_nem_2025_2026');
                        onRemoveClass(LISTADO_DINAMICO_ID, 'onHide');
                        onScrollComponente(LISTADO_DINAMICO_ID);
                    }
                },
                {
                    icon: this._icon.libros,
                    title: 'Libros',
                    portal: ['p_default', 'secundaria'],
                    action: () => {
                        this._conf.labelLinks = 'Libros';
                        this._conf.setlibrosGlobalLinks('secundaria_libros');
                        onRemoveClass(LISTADO_DINAMICO_ID, 'onHide');
                        onScrollComponente(LISTADO_DINAMICO_ID);
                    }
                },
                {
                    icon: this._icon.libros,
                    title: 'Libros SEP',
                    portal: ['p_default', 'bac'],
                    action: () => {
                        this._conf.labelLinks = 'Libros SEP';
                        this._conf.setlibrosGlobalLinks('secundaria_libros');
                        onRemoveClass(LISTADO_DINAMICO_ID, 'onHide');
                        onScrollComponente(LISTADO_DINAMICO_ID);
                    }
                },
                {
                    icon: this._icon.training,
                    title: 'Educación Inclusiva',
                    portal: ['p_default', 'preescolar', 'primaria', 'secundaria'],
                    action: () => {
                        window.open("https://cdnsnte1.s3.us-west-1.amazonaws.com/wp-content/uploads/2020/04/11073434/ENEI.pdf", "_blank");
                    }
                },
                {
                    icon: this._icon.catalogos,
                    title: 'Catálogos de aplicaciones',
                    portal: ['p_default', 'preescolar', 'primaria', 'secundaria', 'bac', 'hab'],
                    action: () => {
                        this._conf.tiposLinkDinamico = 1;
                        this._conf.labelLinks = 'Catálogos de aplicaciones';
                        this._conf.setCatalogosGlobalLinks();
                        onRemoveClass(LISTADO_DINAMICO_ID, 'onHide');
                        onScrollComponente(LISTADO_DINAMICO_ID);
                    }
                }
            ],
            action: () => {
            }
        },
        {
            title: 'Contacto',
            portal: ['crk', 'tecnologia', 'p_default', 'lectura', 'preescolar', 'primaria', 'secundaria', 'bac', 'hab'],
            submenu: [],
            action: () => {
                onAddClass(LISTADO_DINAMICO_ID, 'onHide');
                scrollEnd();
            }
        }
    ];

    /**
     * @description Obtiene el menú filtrado por portal específico
     * @param portal Portal a filtrar (ej: 'p_default', 'p_primaria', 'p_secundaria')
     * @returns Array de MenuItem filtrado por el portal especificado
     */
    public getMenuByPortal(portal: string): MenuItem[] {
        return this.menuCore
            .filter(menuItem => menuItem.portal?.includes(portal))
            .map(menuItem => ({
                ...menuItem,
                submenu: menuItem.submenu?.filter(subItem =>
                    subItem.portal?.includes(portal)
                ) || []
            }));
    }


}


